import React from "react";

import { useReactifySearchContext, useFilters } from "../../hooks";
import { SENSOR_IDS } from "../../components";
import { ConfigFilterOption } from "../../types";

export const useReactiveReactProp = (
  currentHandle?: string,
  filter?: ConfigFilterOption
) => {
  const reactifySearchContext = useReactifySearchContext();
  const { filterStack } = useFilters();
  
  const sensorIds = SENSOR_IDS(reactifySearchContext.options.mode, reactifySearchContext.config);

  const reactProp = React.useMemo(() => {
    if (filter && filter.settingsShowEmptyValues) {
      return {
        and: sensorIds,
      };
    }

    return {
      and: [
        ...sensorIds,
        ...(reactifySearchContext.options.additionalComponentIds ?? []),
        ...(filterStack?.options.map((filter) => filter.handle) ?? []),
      ].filter((handle) => handle !== currentHandle),
    };
  }, [filterStack, currentHandle, reactifySearchContext.options.additionalComponentIds]);

  return reactProp;
};
